import { makeAutoObservable } from "mobx"
import AudienceInformation from "./AudienceInformation"
import AuthenticationHistory from "./AuthenticationHistory"
import Post from "./Post"

export default class Authentication {

  constructor(authentication={}) {
    this.id = authentication.id || null
    this.influencer_id = authentication.influencer_id
    this.modash_updatable = !!authentication.modash_updatable
    this.manually_entered = !!authentication.manually_entered
    this.audience_data_updated_at = authentication.audience_data_updated_at || ''
    this.provider = authentication.provider || null
    this.username = authentication.username || ''
    this.uid = authentication.uid || ''
    this.reach = authentication.reach || 0
    this.engagement_rate = authentication.engagement_rate || 0
    this.avatar = authentication.avatar
    this.bio = authentication.bio || ''
    this.country = authentication.country || ''
    this.modash_country = authentication.modash_country || ''
    this.country_locked = !!authentication.country_locked
    this.city = authentication.city || ''
    this.gender = authentication.gender || ''
    this.age_group = authentication.age_group || ''
    this.audience_information = authentication.audience_information ? new AudienceInformation(authentication.audience_information) : null
    this.authentication_histories = (authentication.authentication_histories || []).filter(ah => ah).map(authentication_history => new AuthenticationHistory(authentication_history))
    this.posts = (authentication.posts || []).filter(post => post).map(post => new Post(post))
    this.similar_authentications = authentication.similar_authentications || []
    this.authentications_hashtags = authentication.authentications_hashtags || []
    this.authentications_mentions = authentication.authentications_mentions || []
    this.description = authentication.description || ''
    this.tags = authentication.tags || []
    this.sponsored_posts = (authentication.sponsored_posts || []).map(post => new Post(post))
    this.sponsored_posts_loaded = !!authentication.sponsored_posts_loaded
    this.sponsored_posts_loading = false
    this.shared_uuid = authentication.shared_uuid || ''
    this.thumbnails = authentication.thumbnails || []
    this.reachbird_approved = !!authentication.reachbird_approved
    this.main_country = authentication.main_country || ''
    this.rating_professional = authentication.rating_professional ?? null
    this.rating_quality = authentication.rating_quality ?? null
    this.rating_count = authentication.rating_count || 0


    makeAutoObservable(this)
  }
}
